import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { filter, takeUntil, tap } from 'rxjs/operators';
import { ContextBarStateService } from '../../../00_modules/contextbar/statemanagement/contextbar-state.service';
import { NavigationItem } from '../../../00_modules/contextbar/services/navigation/models/navigation-item.model';
import { NavigationKeys } from '../../../00_modules/contextbar/services/navigation';
import { IconComponent } from '../../../00_modules/shared/components/fa-icon/fa-icon.component';

interface BadgeInfoViewModel {
    count: string;
    key: NavigationKeys;
}

@Component({
    selector: 'je-context-bar-navigation-badge',
    templateUrl: './context-bar-navigation-badge.component.html',
    imports: [IconComponent],
})
export class ContextBarNavigationBadgeComponent implements OnInit, OnDestroy {
    public badgeInfo: BadgeInfoViewModel;

    constructor(private stateWrapper: ContextBarStateService) {}

    private destroy$ = new Subject<boolean>();
    @Input() public item: NavigationItem;

    public ngOnInit(): void {
        this.stateWrapper.badgeInfo$
            .pipe(
                tap(_ => (this.badgeInfo = null)),
                filter(badgeInfos => !!this.item && !!badgeInfos && badgeInfos.length > 0),
                filter(badgeInfos => badgeInfos.some(bageInfo => bageInfo.key === this.item.key)),
                takeUntil(this.destroy$),
            )
            .subscribe(badgeInfos => {
                const foundInfo = badgeInfos.find(x => x.key === this.item.key);
                if (!foundInfo || foundInfo.count === 0) {
                    return;
                }
                this.badgeInfo = {
                    count: foundInfo.count.toString(),
                    key: foundInfo.key,
                };
            });
    }

    public ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }

    public showBubble(): boolean {
        return this.item.key != NavigationKeys.keyAll;
    }
}
